import type {EstablishedAhpSession} from '@github-ui/ahp-session-client/contracts'
import {ensureSessionMode} from '@github-ui/ahp-session-client/session-mode'
import type {McpPermissionMode} from '@github-ui/agent-sessions-types/mcp-permission-mode'
import type {AgentMode} from '@github-ui/copilot-shared-ui/utils/agent-mode'

import {mapMcpPermissionModeToAgentMode} from '../utils/mcp-permission-mode'

export function resolveEnvironmentTaskStartupMode(
  agentMode: AgentMode | undefined,
  mcpPermissionMode: McpPermissionMode | undefined,
): AgentMode | undefined {
  return agentMode ?? mapMcpPermissionModeToAgentMode(mcpPermissionMode)
}

/**
 * First-turn configuration for a session created with `createSession.config.mode`.
 * The mode itself rides on `createSession`; this only writes it again when the
 * host reports something else (an attached session or a host that does not
 * publish `mode`), and sets allow-all to match.
 */
export async function applyEnvironmentTaskStartupMode(
  session: EstablishedAhpSession,
  mode: AgentMode | undefined,
): Promise<void> {
  if (!mode) return
  await Promise.all([ensureSessionMode(session, mode), session.commands.setApproveAll(mode === 'autopilot')])
}
